import {useContext} from "react";
import {AppContext} from "../../context/AppContext";
import styled from "styled-components";
import userImg from "../../images/user.svg";

export const Header = () => {

    const {companyAccount} = useContext(AppContext);

    if (!companyAccount) {
        return null;
    }

    return <StyledHeader>
        <h1>TRIBAWL Health Care System</h1>
        <div className="welcome">
            {companyAccount.name}
        </div>
    </StyledHeader>

};

const StyledHeader = styled.header`
  height: 50px;
  background-color: #031F69;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  width: 100%;
  
  h1 {
    color: #fff;
    font-size: 20px;
    font-weight: normal;
  }
  
  .welcome {
    color: #fff;
    background-image: url(${userImg});
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 25px;
    font-size: 14px;
    letter-spacing: 2px;
  }
  

`;